import { safeDefine } from "../../registration/safe-define.js";
import { StatusIndicatorValueElement } from "../../ui/status-indicator/value.js";
//#region src/define/ui/status-indicator-value.ts
safeDefine(StatusIndicatorValueElement);
//#endregion

//# sourceMappingURL=status-indicator-value.js.map